
export enum DiariaCandidatoStatus {
    PENDENTE = "Pendente",
    APROVADO = "Aprovado",
    REPROVADO = "Reprovado",
}